import storage from '@utils/storage'

const STORAGE_PAYER_PHONE = 'da.donation.viewerPhone'
const STORAGE_PAYER_EMAIL = 'da.donation.viewerEmail'
const STORAGE_PAYER_QIWI_WALLET = 'da.donation.viewerQiwiWallet'

export const state = {
  phone: storage.getItem(STORAGE_PAYER_PHONE),
  email: storage.getItem(STORAGE_PAYER_EMAIL),
  qiwiWallet: storage.getItem(STORAGE_PAYER_QIWI_WALLET),
}

export const getters = {
  getField,
}

export const mutations = {
  updateField,

  SAVE_PAYER_INFO(state) {
    storage.setItem(STORAGE_PAYER_PHONE, state.phone)
    storage.setItem(STORAGE_PAYER_EMAIL, state.email)
    storage.setItem(STORAGE_PAYER_QIWI_WALLET, state.qiwiWallet)
  },
}

export const actions = {}
